import { computed, Ref } from "@vue/composition-api";

export default function useUploadingProgress(progress: Ref<number>) {
  const loaded = computed(() => progress.value === 100);
  const loading = computed(() => progress.value > 0 && progress.value < 100);

  return {
    loaded,
    loading,
  };
}
